var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPt20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 22.0647 3.37438 27.341 8.34781 30.0546V1.9455C3.37438 4.65912 0 9.93537 0 16.0001Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 23.3925 5.01381 29.6128 11.8261 31.4488V0.551208C5.01381 2.38721 0 8.60758 0 16Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73901 5.56519V8.17387C5.73901 9.47056 6.79014 10.5217 8.08682 10.5217C9.38351 10.5217 10.4346 9.47056 10.4346 8.17387V5.56519H5.73901Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08699 9.13041C7.55955 9.13041 7.13049 8.70135 7.13049 8.17391V6.95654H9.04355V8.17391C9.04355 8.70135 8.61443 9.13041 8.08699 9.13041Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.391 16.6956H13.2171C13.2171 15.9272 12.5941 15.3043 11.8257 15.3043C11.0574 15.3043 10.4344 15.9272 10.4344 16.6956H6.2605C6.2605 17.464 6.92981 18.0869 7.69812 18.0869H7.65181C7.65181 18.8553 8.27462 19.4782 9.04312 19.4782C9.04312 20.2466 9.66594 20.8695 10.4344 20.8695H13.2171C13.9854 20.8695 14.6084 20.2466 14.6084 19.4782C15.3767 19.4782 15.9997 18.8553 15.9997 18.0869H15.9534C16.7217 18.0869 17.391 17.464 17.391 16.6956V16.6956Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9627 14.4692L17.5975 15.054L18.0406 15.582L17.3716 15.4155L17.0063 16L16.9581 15.3122L16.2891 15.1454L16.9285 14.8872L16.8804 14.1993L17.3236 14.7276L17.9627 14.4692Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8314 12.6807L15.6882 13.3552L16.2852 13.6999L15.5995 13.7722L15.4562 14.4465L15.1757 13.8166L14.49 13.8886L15.0024 13.4272L14.7221 12.7975L15.3191 13.1422L15.8314 12.6807Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2172 11.7292L13.3131 12.4121L13.992 12.5317L13.3724 12.834L13.4684 13.5168L12.9895 13.0208L12.3697 13.3231L12.6934 12.7142L12.2145 12.2184L12.8935 12.338L13.2172 11.7292Z",
    fill: "#FFDA44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 11.7292L10.7587 12.338L11.4376 12.2183L10.9587 12.7144L11.2823 13.3231L10.6627 13.0208L10.1837 13.5167L10.2797 12.834L9.66003 12.5318L10.339 12.4121L10.4349 11.7292Z",
    fill: "#FFDA44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82039 12.6807L8.33276 13.1422L8.92976 12.7975L8.64951 13.4275L9.1617 13.8887L8.47614 13.8166L8.19557 14.4465L8.05245 13.7721L7.3667 13.7001L7.9637 13.3552L7.82039 12.6807Z",
    fill: "#FFDA44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68889 14.4692L6.32833 14.7276L6.77127 14.1994L6.72339 14.8873L7.36258 15.1457L6.69352 15.3123L6.64527 16L6.28021 15.4155L5.61121 15.5822L6.05439 15.054L5.68889 14.4692Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt20);
export default __webpack_public_path__ + "static/media/PT-20.f475e00f.svg";
export { ForwardRef as ReactComponent };